<template>
	<UserRegistrationLayout isGoogleSignupMode :hideTopBar="extensionMode" :showProgressBar="showProgressBar">
		<AppLoader v-if="isLoading" />
		<WorkspaceSelectionMenu
			v-else
			title="Select workspace"
			v-on="workspaceMenuHandlers"
			:activeAccount="activeAccount"
			:joinedAccounts="joinedAccounts"
			:invitedAccounts="invitedAccounts"
			class="menu-content-container height-100"
		/>
	</UserRegistrationLayout>
</template>

<script>
import { mapActions } from 'vuex';
import credentials from '@/credentials';
import UserRegistrationLayout from './UserRegistrationLayout.vue';
import UserRegistrationMixin from './helpers/UserRegistrationMixin';
import { WORKSPACE_SELECTION_ROUTE_NAME } from '@/router/router.const.js';
import WorkspaceSelectionMenuMixin from '@/components/WorkspaceSelectionMenu/mixins/WorkspaceSelectionMenuMixin.js';
export default {
	name: WORKSPACE_SELECTION_ROUTE_NAME,
	mixins: [WorkspaceSelectionMenuMixin, UserRegistrationMixin],
	components: { UserRegistrationLayout },
	props: {
		extensionMode: { type: Boolean },
		activeAccountId: { type: Number }, // from extension
		i: { type: Number }, //inbox Id to 'auto accept invitation', comes from BE redirect
	},
	computed: {
		showProgressBar() {
			return !this.extensionMode && this.joinedAccounts.length === 0;
		},
		activeAccount() {
			if (this.activeAccountId) {
				return this.useAccount(this.activeAccountId);
			} else {
				return {};
			}
		},
	},
	methods: {
		...mapActions(['initUser']),
		autoAcceptInvitation() {
			const allAccountsIds = Object.keys(this.accounts).map((id) => String(id));
			if (allAccountsIds.includes(String(this.i))) {
				// if inbox-to-accept-invitation is in invited accounts
				this.acceptInvitation(this.i); // in Mixin
			} else {
				this.$toast.error(`Couldn't find your invitation details, please contact the workspace admin`);
			}
		},
	},
	async created() {
		if (this.extensionMode) {
			return;
		}
		if (this.i) {
			// This check has to come first
			// It will work even if we are not logged in, because of return_to query param
			// Theres a user here for sure, so no need to fetch or wait for available accounts
			this.isLoading = true;
			try {
				await this.initUser();
				await this.autoAcceptInvitation();
			} catch (e) {
				console.error(e);
				this.$toast.error(`Couldn't find your invitation details, please contact the workspace admin`);
			} finally {
				this.isLoading = false;
			}
			return;
		}
		if (this.user?.profile?.account?.id && credentials?.account) {
			return this.$router.push({ name: 'HomePage' });
		}
		if (!this.user) {
			return this.$router.push({ name: 'Logout' });
		}
	},
	data() {
		return { isLoading: false };
	},
};
</script>

<style scoped lang="scss">
.menu-content-container {
	$menu-width: 470px;
	width: $menu-width;
	min-width: $menu-width;
	max-width: $menu-width;
}
::v-deep {
	.inner-content {
		h5 {
			font-size: 22px;
			line-height: 26px;
		}
		h3 {
			display: flex;
		}
	}
	.slot-card {
		overflow: hidden;
		min-height: 359px;
		padding: 0px !important;
	}
	.inner-content {
		padding: 18px 30px 30px 30px !important;
	}
}
</style>
